import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { StockTransferForm } from "@/components/stock-transfers/stock-transfer-form";
import { Id } from "@/convex/_generated/dataModel";

export const Route = createFileRoute(
  "/_authenticated/stock-transfers/$id/edit",
)({
  component: EditStockTransferPage,
});

function EditStockTransferPage() {
  const { id } = Route.useParams();
  return (
    <RouteGuardPermissions
      permissions={[{ module: "stock_transfers", actions: ["read", "update"] }]}
    >
      <StockTransferForm transferId={id as Id<"stock_transfers">} />
    </RouteGuardPermissions>
  );
}
